"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * Form definition converter.
 *
 * @author Radek Beran
 */


var FormDefinitionConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FormDefinitionConverter, _DataObjectConverter_);

  function FormDefinitionConverter() {
    _classCallCheck(this, FormDefinitionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormDefinitionConverter).apply(this, arguments));
  }

  return FormDefinitionConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FormDefinitionConverter = FormDefinitionConverter;